import { render, staticRenderFns } from "./FaUserAstronautPrerendered.vue?vue&type=template&id=45681d98&"
import script from "./FaUserAstronautPrerendered.vue?vue&type=script&lang=js&"
export * from "./FaUserAstronautPrerendered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports